import React, { useContext } from "react";
import { useLazyLoadQuery, graphql } from "react-relay";
import { GreenMachineContext } from "../../GreenMachineContext";

const GET_ERROR_REPORTS = graphql`
  query ErrorReportsQuery {
    greenMachineIssues {
      id
      numLineups
      minSalary
      maxSalary
      playersPerLineup
      reportedBy {
        username
      }
      errorReport
      errorMessage

      greenmachinelineupsetSet {
        edges {
          node {
            id
          }
        }
      }
      slate {
        id
        gameType {
          id
          sport {
            id
            name
          }

          gametypelineupsetSet {
            edges {
              node {
                lineupSet {
                  lineuprosterslotSet {
                    edges {
                      node {
                        order
                        amount
                        rosterSlot {
                          name
                        }
                        selectable
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default function ErrorReports() {
  const {
    setSelectedSlateID,
    setSelectedSportID,
    setSelectedGameTypeID,
    initializeGreenMachineSession,
    jumpToStage,
    setGameTypeLineupSet,
    STAGE_NUMBERS,
  } = useContext(GreenMachineContext);

  const data = useLazyLoadQuery(GET_ERROR_REPORTS);

  return (
    <>
      {data.greenMachineIssues.map((greenMachineSession) => {
        return (
          <p key={greenMachineSession.id} className="gm-session-option">
            <button
              onClick={(e) => {
                e.preventDefault();
                initializeGreenMachineSession(greenMachineSession);

                setSelectedSlateID(greenMachineSession.slate.id);
                setSelectedSportID(greenMachineSession.slate.gameType.sport.id);

                setSelectedGameTypeID(greenMachineSession.slate.gameType.id);
                setGameTypeLineupSet(
                  greenMachineSession.slate.gameType.gametypelineupsetSet
                    .edges[0].node.lineupSet.lineuprosterslotSet.edges
                );

                jumpToStage(STAGE_NUMBERS.lineupConfiguration);
              }}
            >
              {greenMachineSession.slate.gameType.sport.name +
                " " +
                greenMachineSession.reportedBy.username +
                " (" +
                greenMachineSession.errorMessage +
                ")"}
            </button>
          </p>
        );
      })}
    </>
  );
}
